import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function QuickReadingPlus() {
    useEffect(() => {
        document.title = 'КьюАй - Скорочтение +';
    }, [])

    return <>
        <div>
            Вы хотите, чтобы Ваш ребенок стал лидером среди сверстников по скорости чтения? Тогда попробуйте
            Скорочтение + от центра детского развития КьюАй! Методика, разработанная для детей, читающих от 120
            слов в минуту, поможет вашему ребенку развить фонематический слух, улучшить внимание и понимание
            текста, а также поможет в освоении навыка грамотного пересказа прочитанного. На протяжении всего
            курса учитель назначает домашнее задание и отслеживает прогресс ученика. Также курс Скорочтение + -
            это отличная возможность серьезной подготовки к экзаменам для учеников среднего и старшего школьного
            возраста. Присоединяйтесь к КьюАй и дайте своему ребенку шанс на успех!

        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Развитие фонематического слуха;</li>
                    <li>Обучение концентрации внимания на конкретном тексте;</li>
                    <li>Расширение поля зрения;</li>
                    <li>Освоение различных техник скорочтения;</li>
                    <li>Обучение пониманию смысла прочитанного с первого раза;</li>
                    <li>Развитие умения грамотно пересказывать прочитанный текст;</li>
                    <li>Совершенствование навыка смысловой догадки (антиципации);</li>
                    <li>Формирование умения обрабатывать большие объемы информации за короткий промежуток времени;</li>
                    <li>Улучшение школьной успеваемости.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-sch-plus"></div>
            </div>
        </div>
        <div>
            В результате обучения ученик сможет читать минимум в 2-3 раза быстрее, понимать прочитанную
            информацию, быстро запоминать большие объемы данных, улучшить дикцию, повысит концентрацию на чтении
            и быстрее выполнять домашнюю работу. Кроме того, обучение помогает развить внимание, логику,
            образное мышление, мелкую моторику и память. Мы уверяем, что навык скорочтения сохранится на всю
            жизнь. Этот курс определенно стоит вашего внимания!

        </div>
        <div>
            Родители, предлагаем вам использовать уникальную возможность улучшить навыки чтения ваших детей с
            помощью центра детского развития КьюАй. Наш курс Скорочтение + предлагает интересные и динамичные
            занятия, которые помогут вашим детям улучшить скорость чтения и повысить успеваемость в школе. Не
            упустите этот шанс и запишите своих детей на курс Скорочтение + уже сейчас!

        </div>
    </>
}